import { FC, SetStateAction, useState } from "react";
import { TFunction } from "i18next";

import { SetEmployeeOperations } from "services/employeeManagement.service";
import { setActive, setInActive } from "redux/slices/EmployeeManagementSlice";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

import Image, { ICONS } from "components/BaseComponents/Image";
import InsideSpinner from "components/BaseComponents/Spinner/InsideSpinner";
import Button from "components/BaseComponents/Button";
import { StyledEmpPanelActionButton } from "../EmployeePanel/EmployeePanel.styles";
import { TokenInclude } from "helpers/GetToken";
import { useMediaQuery } from "context/media/MediaContext";

interface AgentActiveInactiveProps {
  phoneNumber: string;
  dispatch: any;
  t: TFunction;
  status: string;
  isDetail: boolean;
  setIsAddSuccess?: SetStateAction<any>;
  setIsEditChange?: SetStateAction<any>;
  sts?: string;
  setSts?: SetStateAction<any>;
  setIsAddError?: SetStateAction<any>;
  setTxt?: SetStateAction<any>;
}

const AgentActiveInactive: FC<AgentActiveInactiveProps> = ({
  phoneNumber,
  dispatch,
  t,
  status,
  isDetail,
  setIsAddSuccess,
  setIsEditChange,
  setIsAddError,
  sts,
  setSts,
  setTxt,
}) => {
  const { isMobile } = useMediaQuery();
  const [loading, setLoading] = useState<boolean>(false);
  const [operationNo, setOperationNo] = useState<string>();
  const token = TokenInclude();

  const EmpInactive = async (phoneNumber: string) => {
    setLoading(true);
    setOperationNo("2");
    const isInActive = await SetEmployeeOperations(token, phoneNumber, "2");
    if (isInActive.Issucceeded) {
      setLoading(false);
      setOperationNo("");
      if (isDetail) {
        setIsAddSuccess(true);
        setIsEditChange(false);
        setSts("2");
      }
      dispatch(setInActive(phoneNumber));
    } else {
      const errMessage: any = isInActive;
      setIsAddError && setIsAddError(true);
      setTxt && setTxt(errMessage);
      return;
    }
  };

  const EmpActive = async (phoneNumber: string) => {
    setLoading(true);
    setOperationNo("1");
    const isActive = await SetEmployeeOperations(token, phoneNumber, "1");
    if (isActive.Issucceeded) {
      setLoading(false);
      setOperationNo("");
      if (isDetail) {
        setIsAddSuccess(true);
        setIsEditChange(false);
        setSts("1");
      }
      dispatch(setActive(phoneNumber));
    } else {
      const errMessage: any = isActive;
      setIsAddError(true);
      setTxt(errMessage);
      return;
    }
  };

  return !isDetail ? (
    <StyledEmpPanelActionButton
      bgColor={DIGIPOSTHEME.colors.transparent}
      onClick={() =>
        status === "1" ? EmpInactive(phoneNumber!) : EmpActive(phoneNumber!)
      }
    >
      {loading && (operationNo === "1" || operationNo === "2") ? (
        <InsideSpinner width='30' height='30' />
      ) : (
        <>
          <Image
            borderRadius='5px'
            backgroundColor={DIGIPOSTHEME.colors.transparent}
            alt='Menu Icon'
            height='24px'
            srcSet={status === "1" ? ICONS.CLOSE_EYE : ICONS.OPEN_EYE}
            width='22px'
            margin='0 5px'
            tooltipInfo={
              status === "1"
                ? t("agent_inactive").toString()
                : t("agent_active").toString()
            }
          />
        </>
      )}
    </StyledEmpPanelActionButton>
  ) : (
    <Button
      width={isMobile ? "100%" : "130px"}
      margin={isMobile ? "" : "0 10px"}
      text={
        loading && (operationNo === "1" || operationNo === "2") ? (
          <InsideSpinner
            width='30'
            height='30'
            isWhite={sts === "1" ? true : false}
          />
        ) : sts === "1" ? (
          t("agent_inactive").toString()
        ) : (
          t("agent_active").toString()
        )
      }
      type='button'
      onClick={() =>
        sts === "1" ? EmpInactive(phoneNumber!) : EmpActive(phoneNumber!)
      }
      color={sts === "1" ? "light" : "primary"}
    />
  );
};

export default AgentActiveInactive;
